import angular from 'angular';
import loansCatalogCardComponent from './loansCatalogCard.component';
import loansCatalogCardButtons from './loansCatalogCardButtons/loansCatalogCardButtons';

let loansCatalogCardModule = angular.module('loansCatalogCard', [
  loansCatalogCardButtons,
])

.component('loansCatalogCard', loansCatalogCardComponent)

.name;

export default loansCatalogCardModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansCatalog/loansCatalogCard/loansCatalogCard.js